<template>
  <div id="app">
    <img src="./assets/logo.png">
    <input id="input_scancode" v-model="scancode" readonly type="text" @keyup.enter="OnSumit">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      scancode: window.js.getDevId()
    }
  },
  mounted () {
    window.addEventListener('keypress', e => {
      if ((e.keyCode >= 0x30 && e.keyCode <= 0x39) || (e.keyCode >= 0x41 && e.keyCode <= 0x5a) || (e.keyCode >= 0x61 && e.keyCode <= 0x7a)) {
        this.scancode = this.scancode + e.key
      } else if (e.key === 'Enter') {
        this.scancode = ''
      }

      console.info(String.fromCharCode(e.keyCode))
    })
  }
}

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue